import { Stepper } from 'primereact/stepper';
import { StepperPanel } from 'primereact/stepperpanel';
import { TabPanel } from 'primereact/tabview';
import formlabels from '../data/formlabels.json';
import HomeAddress from './HomeAddress';
import PersonalIdentity from './PersonalIdentity';
import Busline from './Busline';
import Authority from './Authority';
import Chapitre from './Chapitre';
import Summary from './Summary';

type RenderFamilyMemberFormArgs = {
  sfd: (a: any) => void;
  fd: any[];
  familyMember: any;
  labelslanguage: string;
  jumptolasttab: (e: any) => void;
  addFamilyMember: () => void;
  isFormFieldValid: (meta: any) => boolean;
  getFormErrorMessage: (meta: any) => any;
  getPrices: (bld: any, birthDate: string) => any;
  exactPrice: (member: any) => any;
  busLines: any[];
  chapitres: any[];
};

const renderFamilyMemberForm = ({
  sfd,
  fd,
  familyMember,
  labelslanguage,
  jumptolasttab,
  addFamilyMember,
  isFormFieldValid,
  getFormErrorMessage,
  getPrices,
  exactPrice,
  busLines,
  chapitres,
}: RenderFamilyMemberFormArgs) => {
  const labels = (formlabels as any)[labelslanguage];
  familyMember.currentStep = familyMember.currentStep || 0;

  return (
    <TabPanel
      key={familyMember.personID}
      header={familyMember.name || (labels.user + ' ' + familyMember.personID)}
      closable={familyMember.personID > 0}
      leftIcon={'pi mr-2 pi-user' + (familyMember.currentStep === 4 ? '' : '-edit')}
    >
      <Stepper linear={true} orientation="vertical" activeStep={familyMember.currentStep}>
        <StepperPanel header={labels.identity} key="identity">
          <PersonalIdentity
            familyMember={familyMember}
            sfd={sfd}
            labels={labels}
            isFormFieldValid={isFormFieldValid}
            getFormErrorMessage={getFormErrorMessage}
          />
        </StepperPanel>
        <StepperPanel header={labels.legalDetails} key="legal">
          {familyMember.personID > 0 ? (
            <Authority
              familyMember={familyMember}
              sfd={sfd}
              fd={fd}
              labels={labels}
              isFormFieldValid={isFormFieldValid}
              getFormErrorMessage={getFormErrorMessage}
            />
          ) : (
            <HomeAddress
              familyMember={familyMember}
              sfd={sfd}
              fd={fd}
              labels={labels}
              isFormFieldValid={isFormFieldValid}
              getFormErrorMessage={getFormErrorMessage}
            />
          )}
        </StepperPanel>
        <StepperPanel header={labels.busLine} key="busline">
          <Busline
            familyMember={familyMember}
            sfd={sfd}
            labels={labels}
            busLines={busLines}
            labelslanguage={labelslanguage}
            isFormFieldValid={isFormFieldValid}
            getFormErrorMessage={getFormErrorMessage}
            getPrices={getPrices}
          />
        </StepperPanel>
        <StepperPanel header={labels.chapitre} key="chapitre">
          <Chapitre
            familyMember={familyMember}
            sfd={sfd}
            labels={labels}
            busLines={busLines}
            chapitres={chapitres}
            isFormFieldValid={isFormFieldValid}
            getFormErrorMessage={getFormErrorMessage}
          />
        </StepperPanel>
        <StepperPanel header={labels.summary} key="summary">
          <Summary
            familyMember={familyMember}
            labels={labels}
            sfd={sfd}
            jumptolasttab={jumptolasttab}
            exactPrice={exactPrice}
            addmember={() => addFamilyMember()}
          />
        </StepperPanel>
      </Stepper>
    </TabPanel>
  );
};

export default renderFamilyMemberForm;
